import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

/**
 * Native ports of the three ``hc-block--jdpower-2024--*`` banner partials.
 *
 * Legacy ``static_image`` renders EAGER under puppeteer (plain ``<img>`` with
 * the static URL); image ``src`` values are built from the reactivated
 * ``STATIC_URL`` context (``useStaticURL``) -- SSR-safe and byte-identical to
 * the legacy ``{% static %}`` output, unlike a Vite asset import.
 * ``width``/``height``/``class`` attrs preserved verbatim. ``<sup>+</sup>`` kept
 * directly adjacent to preceding text (no whitespace).
 */

export const JdPower2024BannerCenteredWithYears = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2024 hc-banner-jdpower-2024--centered-with-years">
            <div>
                <div className="image-container">
                    <img
                        src={`${staticURL}img/hardcoded/jdpower-2024--quadruple.png`}
                        alt="2024 JD Power Award Trophy"
                        width="240px"
                        height="120px"
                        className="hc-banner-jdpower-2024__image-centered-with-years"
                        loading="lazy"
                        decoding="async"
                    />
                    <p>
                        <span>2024</span>
                        <span>2023</span>
                        <span>2022</span>
                        <span>2021</span>
                    </p>
                </div>
                <div className="content-container">
                    <h3>
                        #1 in Customer Satisfaction with Mattresses Purchased
                        Online
                    </h3>
                    <p>
                        — Awarded by J.D. Power 4 Years in a Row<sup>+</sup>
                    </p>
                </div>
            </div>
        </div>
    );
};

export const JdPower2024BannerFirstVersion = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2024 hc-banner-jdpower-2024--first-version">
            <div>
                <div className="image-container">
                    <img
                        src={`${staticURL}img/hardcoded/jdpower-2024--quadruple-first-version.png`}
                        alt="2024 JD Power Award Trophy"
                        width="200px"
                        height="140px"
                        className="hc-banner-jdpower-2024__image-first-version"
                        loading="lazy"
                        decoding="async"
                    />
                    <div className="years">
                        <span>2024</span>
                        <span>2023</span>
                        <span>2022</span>
                        <span>2021</span>
                    </div>
                </div>
                <div className="content-container">
                    <h3>
                        <sup>+</sup>
                    </h3>
                    <section
                        className="features-row"
                        role="group"
                        aria-label="Top Features"
                    >
                        <article className="features-row--first">
                            <div>
                                <span>#1</span>&nbsp;Comfort
                            </div>
                            <div>
                                <span>#1</span>&nbsp;Support
                            </div>
                            <div>
                                <span>#1</span>&nbsp;Value for Price Paid
                            </div>
                        </article>
                        <article className="features-row--second">
                            <div>
                                <span>#1</span>&nbsp;Warranty
                            </div>
                            <div>
                                <span>#1</span>&nbsp;Durability
                            </div>
                        </article>
                    </section>
                </div>
            </div>
        </div>
    );
};

export const JdPower2024BannerQuadruple = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2024 hc-banner-jdpower-2024--quadruple">
            <div>
                <img
                    src={`${staticURL}img/hardcoded/jdpower-2024--quadruple.png`}
                    alt="2024 JD Power Award Trophy"
                    width="256px"
                    height="134px"
                    className="hc-banner-jdpower-2024__image-quadruple"
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>
                        #1 in Customer Satisfaction{" "}
                        <span>with Mattresses Purchased Online</span>
                    </h3>
                    <p>
                        — Awarded by J.D. Power in{" "}
                        <span>
                            2024, 2023, 2022 & 2021<sup>+</sup>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};
